import { Events, SessionProvider } from 'core/infrastructure';


let lastActitivy = -1;
let disabled = false;

export function start() {

	document.addEventListener('mousemove', registerUserActivity);
	document.addEventListener('keydown', registerUserActivity);
	//Registro el click porque en iOS los eventos de pulsar la pantalla los registra como click y no como 
	//mousemove
	document.addEventListener('click', registerUserActivity);

	// Mientras el bridge-proxy está lanzando una petición, asumo que el usuario está haciendo algo porque
	// podría tener una ventana levantada. No es del todo cierto, y podría llegar a ocurrir que en una petición
	// de background, por ejemplo de lectura de huellas, se resetease el contador de inactividad, pero de
	// momento esto nos servirá porque las pantallas que hacen proceso en background ya están mostrando una
	// ventana en el TPV (por ejemplo, al hacer un fichaje o autorizar un descuento) y, por tanto, ya no se
	// está aplicando el cierre automático de sesión.
	Events.on('user-activity:action-in-course', async () => registerUserActivity());

	setInterval(checkUserActivity, 1000);
}


// Permito registrar una interacción para casos como el lector de huellas, que no implican interacción
// con el sistema (no hay ratón ni teclado involucrado), pero representan una interacción del usuario.
// Si no, tengo el problema de tras cerrarse la sesión por inactividad, si alguien se logea usando el
// lector de huellas, como no ha habido interacción nueva con el sistema, se cierra automáticamente la
// sesión otra vez.
export function registerUserActivity() {
	lastActitivy = +new Date();
}

export async function registerWhile<T>(action: () => Promise<T>): Promise<T> {
	try {
		disabled = true;

		const result = await action();
		registerUserActivity();

		return result;
	}
	finally {
		disabled = false;
	}

}

async function checkUserActivity() {
	const { enabled, seconds } = SessionProvider.getAutoCloseSession();

	if (!enabled)
		return;

	// Todavía no se ha empezado a usar la aplicación
	if (lastActitivy < 0)
		return;

	const now = new Date();
	const idleMillis = +now - lastActitivy;
	const timeoutMillis = seconds * 1000;

	if (idleMillis > timeoutMillis && !disabled) {
		await Events.raise('session:timeout');
	}
}